export class ProductsModel {
    products: Array<Product>
    tipos: Array<string>
}

export class Product {
    name: string;
    description: string;
    images: Array<string>;
    bula_paciente: string;
    bula_ampliada: string;
    bula_audio: string;
    bula_profissional: string;
    tipo_produto: string;
    subtitulo_produto: string;
}


// WEBPACK FOOTER //
// ./src/pages/produtos/produtos.modelview.ts